'use strict'

import React from 'react';

import {RiskReport} from '../Risk.jsx';
import {IssueReport} from '../Change.jsx';
import FormattedContent from '../components/FormattedContent.jsx';
import Status from '../components/Status.jsx';

import ReportSection from './ReportSection.jsx';
import formatTime from './formatTime.js';
import formatDate from './formatDate.js';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
]);

export class HighlightArea extends React.Component {
  render() {
    var imageStyle=this.props.settings!==undefined && this.props.settings.image? this.props.settings.image.style : undefined;
    var imagePrefix=this.props.settings!==undefined && this.props.settings.image? this.props.settings.image.prefix : undefined;
    return (
      <div style={{paddingBottom:10}}>
        <h3>{this.props.label} <Status style={imageStyle} prefix={imagePrefix} value={this.props.status}/></h3>
        <div>
          <FormattedContent value={this.props.content}/>
        </div>
      </div>
    );
  }
}

class HighlightVariable extends React.Component {
  render() {
    var imageStyle=this.props.settings!==undefined && this.props.settings.image? this.props.settings.image.style : undefined;
    var imagePrefix=this.props.settings!==undefined && this.props.settings.image? this.props.settings.image.prefix : undefined;
    return (
      <div style={{display:"table-row", borderBottom:"solid 1px #4472C4", backgroundColor:this.props.backgroundColor}}>
        <div style={{display:"table-cell", padding:5, paddingBottom:15, verticalAlign:"top"}}>
          <b>{this.props.label}</b>
        </div>
        <div style={{display:"table-cell", padding:5, paddingBottom:15, textAlign:"center", verticalAlign: "top"}}>
           <Status style={imageStyle} prefix={imagePrefix} value={this.props.status}/>
        </div>
        <div style={{display:"table-cell", padding:5, paddingBottom:15}}>
          <FormattedContent value={this.props.content}/>
        </div>
      </div>
    );
  }
}


export class ReportMessage extends React.Component {
  render() {
    var label=this.props.label!==undefined ? this.props.label : "";
    var timestamp=(this.props.timestamp!==undefined) ? formatTime(this.props.timestamp) : "";
    var message=this.props.message!==undefined ? this.props.message : (label+" "+timestamp).trim();
    return (
      <div style={{color:"#212121", fontFamily:"Lato", backgroundColor:"#FFEADB", padding:10, textAlign:"center"}}>
        {message}
      </div>
    );
  }
}

export class TitleAndSummary extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).report.highlight;
    var date=formatDate(this.props.date,labels.undefinedDate);
    var stage=this.props.stage!==undefined && this.props.stage!==null && this.props.project!==undefined && this.props.project.stages!==undefined ? this.props.project.stages.filter(stage=>stage.id===this.props.stage.id)[0] : undefined;
    let nameAndDate=this.props.endProject===true || stage!==undefined ? (
      <div>
        {this.props.project!==undefined ? (
          <div>{this.props.project.name}</div>
        ) : null}
      </div>
    ) : (this.props.project!==undefined ? this.props.project.name+" - " : "")+date;
    var title=this.props.endProject
      ? labels.endProjectReport
      : stage!==undefined ? labels.endStageReport+" - "+(stage.name) : labels.title;
    const manager=this.props.manager!==undefined ? this.props.manager : undefined;

    return (
      <div>
        <div style={{textAlign:"center", marginBottom:10}}>
          <h2 style={{marginBottom: 0}}>
            <div style={{fontSize: "120%"}}>{title}</div>
            <div>{nameAndDate}</div>
          </h2>
          {manager!==undefined ? (
            <div style={{padding:5}}>{labels.managedBy}: {manager.name}</div>
          ) : null}
          {this.props.endProject===true || stage!==undefined ? (
            <div>{labels.start} {formatDate(this.props.from,labels.undefinedDate)}, {labels.end} {formatDate(this.props.date,labels.undefinedDate)}</div>
          ) : null}
        </div>
        {this.props.type==="draft" ? <ReportMessage {...this.props} label={labels.draftSaved}/> : null}
        {this.props.type==="preview" ? <ReportMessage {...this.props} label={labels.preview}/> : null}
        <HighlightArea settings={this.props.settings} label={labels.summary} {...this.props.summary}/>
      </div>
    );
  }
}

class PerformanceAspects extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).report.highlight;
    var style=Object.assign({},{maxWidth:1016},this.props.settings!==undefined ? this.props.settings.style : undefined);
    var aspectsStyle=Object.assign({},[{},{},{}],this.props.settings!==undefined ? this.props.settings.aspectsTable : undefined);
    return (
      <div style={{pageBreakAfter:"always",marginTop:20, width: "100%", display:"table", borderSpacing:10, borderCollapse:"collapse", border:"solid 1px #4472C4"}}>
        <div style={{display:"table-row", backgroundColor:"#4472C4", color:"white", fontWeitgh:"bold"}}>
          <div style={Object.assign({},{display:"table-cell", width:100,padding:5},aspectsStyle[0])}>
            {labels.aspect}
          </div>
          <div style={Object.assign({},{display:"table-cell", width: 90, padding:5, textAlign:"center"},aspectsStyle[1])}>
            {labels.status}
          </div>
          <div style={Object.assign({},{display:"table-cell", padding:5},aspectsStyle[2])}>
            {labels.description}
          </div>
        </div>
        <HighlightVariable settings={this.props.settings} label={labels.benefits} {...this.props.benefits}/>
        <HighlightVariable settings={this.props.settings} backgroundColor="#D9E2F3" label={labels.time} {...this.props.time}/>
        <HighlightVariable settings={this.props.settings} label={labels.cost} {...this.props.cost}/>
        <HighlightVariable settings={this.props.settings} backgroundColor="#D9E2F3" label={labels.quality} {...this.props.quality}/>
        <HighlightVariable settings={this.props.settings} label={labels.scope} {...this.props.scope}/>
        <HighlightVariable settings={this.props.settings} backgroundColor="#D9E2F3" label={labels.risk} {...this.props.risk}/>
    </div>
    );
  }
}


class RiskReportSection extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).report.highlight;

    return (
      <div style={{paddingTop:30}}>
        <h2>{labels.risk}</h2>
        <RiskReport {...this.props} items={this.props.risk.items.filter(item=>item.status!=="Closed")}/>
        <br/>{labels.listLimitedTo}<b> {labels.top5Risks}</b>
      </div>
    );
  }
}

class IssueReportSection extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).report.highlight;

    return (
      <div style={{paddingTop:30}}>
        <h2>{labels.issues}</h2>
        <IssueReport {...this.props} items={this.props.change.items.filter(item=>item.status!=="Closed")}/>
          <br/>{labels.listLimitedTo}<b> {labels.top5Issues}</b>
      </div>
    );
  }
}

export default class HighlightReport extends React.Component {

  render() {
    let labels=translations.getTranslation(this.props).report.highlight;
    var style=Object.assign({},{maxWidth:1016},this.props.settings!==undefined ? this.props.settings.style : undefined);
    var stage=this.props.stage!==undefined && this.props.stage!==null && this.props.project!==undefined && this.props.project.stages!==undefined ? this.props.project.stages.filter(stage=>stage.id===this.props.stage.id)[0] : undefined;
    var presentationMode=this.props.presentationMode!==undefined ? this.props.presentationMode : false;
    var performedTitle=this.props.endProject
      ? labels.projectDeliverables
      : stage!==undefined ?  labels.deliveryStatus : labels.currentPeriod+ (this.props.from!==undefined && this.props.from!==null ? " ("+labels.from+" "+formatDate(this.props.from)+")": "");
    let performed=<ReportSection label={performedTitle} value={this.props.performedAchivements}/>;
    let slide =  this.props.slideNo===0 ? <TitleAndSummary {...this.props}/> :
                 this.props.slideNo===1 ? (stage===undefined ?  performed  : undefined) :
                 this.props.slideNo===2 ? ((stage===undefined && this.props.endProject!==true) ? <ReportSection label={labels.nextPeriod} value={this.props.plannedAchivements}/> : undefined) :
                 this.props.slideNo===3 ? <PerformanceAspects {...this.props}/> :
                 this.props.slideNo===4 ? ((this.props.endProject || stage!==undefined) && this.props.teamPerformance!==undefined ? <ReportSection label={labels.teamPerformance} value={this.props.teamPerformance}/> : undefined) :
                 this.props.slideNo===5 ? ((this.props.endProject || stage!==undefined) && this.props.lessonsDescription!==undefined ? <ReportSection label={labels.lessonsDescription} value={this.props.lessonsDescription}/> : undefined) :
                 this.props.slideNo===6 ? (stage!==undefined ? performed : undefined) :

                 this.props.slideNo===7 ?
                 (((this.props.settings===undefined || this.props.settings!==undefined && this.props.settings.includedRisk!==false)
                  && this.props.risk!==undefined && this.props.risk.items!==undefined && this.props.risk.items!==null
                  && this.props.risk.items.length>0 && this.props.risk.items.filter(item=>item.status!=="Closed").length>0) ? (
                      <RiskReportSection {...this.props}/>
                  ) : undefined) :

                this.props.slideNo===8 ?
                (((this.props.settings===undefined || this.props.settings!==undefined && this.props.settings.includedIssues!==false)
                  && this.props.change!==undefined && this.props.change!==null && this.props.change.items!==undefined && this.props.change.items!==null
                  && this.props.change.items.length>0 && this.props.change.items.filter(item=>item.status!=="Closed").length>0) ? (
                      <IssueReportSection {...this.props}/>
                  ) : undefined) :
                  undefined;
    return (
      presentationMode!==true ? (
        <div style={style}>

          <TitleAndSummary {...this.props}/>
          {stage===undefined ? performed : null}
          {stage===undefined && this.props.endProject!==true ? <ReportSection label={labels.nextPeriod} value={this.props.plannedAchivements}/> : null}
          <PerformanceAspects {...this.props}/>
          {(this.props.endProject || stage!==undefined) && this.props.teamPerformance!==undefined ? <ReportSection label={labels.teamPerformance} value={this.props.teamPerformance}/> : null}
          {(this.props.endProject || stage!==undefined) && this.props.lessonsDescription!==undefined ? <ReportSection label={labels.lessonsDescription} value={this.props.lessonsDescription}/> : null}
          {stage!==undefined ? performed : null}

          {((this.props.settings===undefined || this.props.settings!==undefined && this.props.settings.includedRisk!==false)
            && this.props.risk!==undefined && this.props.risk.items!==undefined && this.props.risk.items!==null
            && this.props.risk.items.length>0 && this.props.risk.items.filter(item=>item.status!=="Closed").length>0) ? (
                <RiskReportSection {...this.props}/>
            ) : null}

          {((this.props.settings===undefined || this.props.settings!==undefined && this.props.settings.includedIssues!==false)
            && this.props.change!==undefined && this.props.change!==null && this.props.change.items!==undefined && this.props.change.items!==null
            && this.props.change.items.length>0 && this.props.change.items.filter(item=>item.status!=="Closed").length>0) ? (
                <IssueReportSection {...this.props}/>
            ) : null}

        </div> ) : slide!==undefined ? (<div style={style}> {slide} </div>) : null

    );
  }
}

export class HighlightReportSlideTitle extends React.Component {

  render() {
    let labels=translations.getTranslation(this.props).report.highlight;
    var stage=this.props.stage!==undefined && this.props.stage!==null && this.props.project!==undefined && this.props.project.stages!==undefined ? this.props.project.stages.filter(stage=>stage.id===this.props.stage.id)[0] : undefined;
    var performedTitle=this.props.endProject
      ? labels.projectDeliverables
      : stage!==undefined ?  labels.deliveryStatus : labels.currentPeriod+ (this.props.from!==undefined && this.props.from!==null ? " ("+labels.from+" "+formatDate(this.props.from)+")": "");
    let slideTitle = this.props.slideNo===0 ? labels.summary :
                     this.props.slideNo===1 ? (stage===undefined ?  labels.currentPeriod : undefined) :
                     this.props.slideNo===2 ? ((stage===undefined && this.props.endProject!==true) ? labels.nextPeriod : undefined) :
                     this.props.slideNo===3 ? labels.aspect :
                     this.props.slideNo===4 ? ((this.props.endProject || stage!==undefined) && this.props.teamPerformance!==undefined ? labels.teamPerformance : undefined) :
                     this.props.slideNo===5 ? ((this.props.endProject || stage!==undefined) && this.props.lessonsDescription!==undefined ? labels.lessonsDescription : undefined) :
                     this.props.slideNo===6 ? (stage!==undefined ? labels.deliveryStatus  : undefined) :

                     this.props.slideNo===7 ?
                     (((this.props.settings===undefined || this.props.settings!==undefined && this.props.settings.includedRisk!==false)
                      && this.props.risk!==undefined && this.props.risk.items!==undefined && this.props.risk.items!==null
                      && this.props.risk.items.length>0 && this.props.risk.items.filter(item=>item.status!=="Closed").length>0) ? (
                          labels.risk
                      ) : undefined) :

                    this.props.slideNo===8 ?
                    (((this.props.settings===undefined || this.props.settings!==undefined && this.props.settings.includedIssues!==false)
                      && this.props.change!==undefined && this.props.change!==null && this.props.change.items!==undefined && this.props.change.items!==null
                      && this.props.change.items.length>0 && this.props.change.items.filter(item=>item.status!=="Closed").length>0) ? (
                          labels.issues
                      ) : undefined) :
                      undefined;
    return (
        slideTitle!==undefined ? <div>{slideTitle}</div> : null
    );
  }
}



// WEBPACK FOOTER //
// ./views/log/HighlightReport.jsx